import { Choices } from 'services/hitchit/types/Choices';

export const filterChoices = (choices: Choices = {}, relatedTo: string): Choices => {
  return Object.entries(choices || {}).reduce((acc, [key, value]) => {
    if (value.relatedTo === relatedTo) {
      acc[key] = value;
    }
    return acc;
  }, {} as Choices);
};
